import { AxiosError } from "axios";
import { axiosInstanceLegacy } from "@rentablo/api";
import { axiosErrorToApiException } from "@api/v1/axiosErrorToApiException";
import { LegacyLoginParams, LegacyLoginResponse } from "../model";

export const sessionLogin = async ({
  email,
  password,
  rememberMe = false,
}: LegacyLoginParams) => {
  try {
    // Credentials belong in the body: a query string is written verbatim into
    // every access log along the path and into Sentry's XHR breadcrumbs.
    const body = new URLSearchParams({
      username: email,
      password: password,
      "remember-me": String(rememberMe),
    });
    const { data } = await axiosInstanceLegacy.post<LegacyLoginResponse>(
      `/login/authenticate`,
      body
    );
    return data;
  } catch (err) {
    const apiException = axiosErrorToApiException(err as AxiosError);
    if (
      apiException?.code === 410 &&
      apiException?.errors &&
      apiException?.errors[0].code === "SESSION_REFRESHED"
    )
      return {};
    throw err;
  }
};
